import store from '@app/store';
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary';
import MobileAppGate from '@components/MobileAppGate/MobileAppGate';
import { ToastProvider } from '@components/Toast';
import env from '@config/env';
import { getAntdTheme, getTheme } from '@config/theme';
import AppNavigationBinder from '@hooks/AppNavigationBinder';
import LogoutConfirmProvider from '@hooks/LogoutConfirmProvider';
import MerchantNavigationBinder from '@modules/merchant/hooks/MerchantNavigationBinder';
import AppRoutes from '@routes/AppRoutes';
import { setupInterceptors } from '@services/interceptor';
import { ConfigProvider } from 'antd';
import { memo, useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

const applyPortalFavicon = () => {
  const theme = getTheme();
  const href = theme.favicon;
  if (!href) return;

  const existing = document.querySelector("link[rel='icon']");
  const link = existing || document.createElement('link');
  link.setAttribute('rel', 'icon');
  link.setAttribute('type', href.endsWith('.svg') ? 'image/svg+xml' : 'image/x-icon');
  link.setAttribute('href', href);
  if (!existing) {
    document.head.appendChild(link);
  }

  if (theme.themeColor) {
    const meta =
      document.querySelector('meta[name="theme-color"]') || document.createElement('meta');
    meta.setAttribute('name', 'theme-color');
    meta.setAttribute('content', theme.themeColor);
    if (!meta.parentNode) {
      document.head.appendChild(meta);
    }
  }
};

setupInterceptors();

const App = memo(() => {
  useEffect(() => {
    document.title = env.APP_NAME;
    document.documentElement.setAttribute('data-portal', env.APP_TYPE);
    applyPortalFavicon();
  }, []);

  return (
    <Provider store={store}>
      <ConfigProvider theme={getAntdTheme()}>
        <ToastProvider>
          <ErrorBoundary>
            <MobileAppGate>
              <BrowserRouter>
                <LogoutConfirmProvider>
                  <AppNavigationBinder />
                  <MerchantNavigationBinder />
                  <AppRoutes />
                </LogoutConfirmProvider>
              </BrowserRouter>
            </MobileAppGate>
          </ErrorBoundary>
        </ToastProvider>
      </ConfigProvider>
    </Provider>
  );
});

App.displayName = 'App';
export default App;
